"use client";

import React from "react";
import QuickContact from "@/components/common/QuickContact";
import BusinessBannerHome from "@/components/pageComponent/business/mobileHome";
import BusinessStartHereMobile from "@/components/pageComponent/business/mobileStarts";
import PostGraduatePrograms from "@/components/pageComponent/business/mobileCertification";
import EdWorkMobile from "@/components/pageComponent/business/edworkMobile";
import EntrepreneursMobile from "@/components/pageComponent/business/enterMobile";
import UnderGraduateMobile from "@/components/pageComponent/business/underGraduateMobile";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
// import CallNowButton from "@/components/common/callNowButton";

const MobilePage: React.FC = () => {
  return (
    <div className="w-full ">
      <div className="bg-[#191919] w-full blue_shadow z-[99]">
        <GlobalHeaderNew />
      </div>
      <BusinessBannerHome />
      <BusinessStartHereMobile />
      <div className="" id="discover">
        <PostGraduatePrograms />
      </div>
      <EntrepreneursMobile />
      <EdWorkMobile />
      <UnderGraduateMobile />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
      {/* <CallNowButton /> */}
    </div>
  );
};

export default MobilePage;
